import { createReducer } from 'immutable-reducers';
import { fromJS, Map } from 'immutable';
import _ from 'lodash';

import { TIME_SLOTS, VISIT_AND_UNITS } from '../constants/actionTypes';

const findBeginAndEnd = (timeSlots) => {
    let begin = '235999', end = '0';
    
    _.each(timeSlots, (d) => {
        _.each(d, (timeSlot) => {
            begin = Math.min(begin, timeSlot.begin);
            end = Math.max(end, timeSlot.end);
        });
    });

    return {
        begin: begin,
        end: end
    };
};

export default createReducer(['timeSlotConfig'], (state = Map(), action) => {

    switch (action.type) {

        case VISIT_AND_UNITS.CLEAR:
        case TIME_SLOTS.REQUEST:
        case TIME_SLOTS.ERROR:
            return Map();

        case TIME_SLOTS.SUCCESS:
            return fromJS(findBeginAndEnd(action.timeSlots));

        default:
            break;
    }

    return state;
});